import { formatCurrency } from "helpers";
import { FleetVehicleExpenseStats } from "services/api/fleet/vehicles/expenses/types";

interface VehicleExpenseStatsHeaderProps {
    stats: FleetVehicleExpenseStats;
    title?: string;
    subtitle?: string;
}

const VehicleExpenseStatsHeader: React.FC<VehicleExpenseStatsHeaderProps> = ({
    stats,
    title = "Troškovi vozila",
    subtitle = "Kumulativni pregled do trenutnog mjeseca",
}) => {
    const totalExpenses = stats.totalAmount;
    const currentPrice = stats.sellingPriceHistory.length > 0
        ? stats.sellingPriceHistory[stats.sellingPriceHistory.length - 1].price
        : 0;
    const diff = currentPrice - totalExpenses;

    return (
        <div className="flex items-start justify-between mb-6">
            <div className="flex items-center gap-3">
                <div>
                    <span className="text-md font-semibold text-slate-900">{title}</span>
                    <div className="text-sm text-slate-500">{subtitle}</div>
                </div>
            </div>
            <div className="min-w-[220px] text-sm">
                <div className="flex justify-between items-baseline gap-4 py-0.5">
                    <span className="text-slate-500">Prodajna cijena</span>
                    <span className="font-semibold text-emerald-600">{formatCurrency.format(currentPrice)}</span>
                </div>
                <div className="flex justify-between items-baseline gap-4 py-0.5">
                    <span className="text-slate-500">Ukupni troškovi</span>
                    <span className="font-semibold text-rose-500">−{formatCurrency.format(totalExpenses)}</span>
                </div>
                <div className="border-t border-slate-200 my-1" />
                <div className="flex justify-between items-baseline gap-4 py-0.5">
                    <span className="text-slate-600 font-semibold">Razlika</span>
                    <span className={`text-lg font-bold ${diff >= 0 ? "text-slate-900" : "text-red-600"}`}>
                        {formatCurrency.format(diff)}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default VehicleExpenseStatsHeader;
